// navLinks.js
import {
  Smartphone,
  CreditCard,
  Database,
  Settings,
  Users,
  Cloud,
  Lock,
  TrendingUp,
  Zap,
  Globe,
  Layers,
  Book,
} from 'react-feather';

export const paymentSolutions = [
  {
    title: 'User-Facing Platforms',
    items: [
      {
        icon: Smartphone,
        label: 'LonaPay Mobile App',
        desc: 'Android/iOS app for riders & fleet operators. Track balances, repay, and find stations.',
        link: '/products/mobile-app',
      },
      {
        icon: CreditCard,
        label: 'Gas Token Wallet',
        desc: 'Daily/48-hour fuel tokens, repayable via Mobile Money or Bank.',
        link: '/products/gas-token',
      },
      {
        icon: Users,
        label: 'AdvancePay Contractors',
        desc: 'Upload invoices, get early payouts, and auto-settle with buyers.',
        link: '/products/advancepay',
      },
      {
        icon: Zap,
        label: 'USSD Interface',
        desc: 'Offline balance checks, token requests, and repayments via USSD.',
        link: '/products/ussd',
      },
    ],
  },
  {
    title: 'Enterprise & Admin Tools',
    items: [
      {
        icon: Settings,
        label: 'HQ Admin Console',
        desc: 'Roles, permissions, audit logs, and branding for HQ teams.',
        link: '/products/admin-console',
      },
      {
        icon: Database,
        label: 'FuelChain Engine',
        desc: 'Automates settlements and exports for finance/auditors.',
        link: '/products/fuelchain',
      },
      {
        icon: Lock,
        label: 'Security Module',
        desc: '2FA, IP whitelisting, and session tracking for admins.',
        link: '/products/security',
      },
      {
        icon: Users,
        label: 'Provider Suite',
        desc: 'Approve/suspend providers, set caps, and track repayments.',
        link: '/products/provider-suite',
      },
    ],
  },
  {
    title: 'APIs & Integrations',
    items: [
      {
        icon: Cloud,
        label: 'Gateway APIs',
        desc: 'Integrate with Flutterwave, Paystack, and MTN Mobile Money.',
        link: '/products/apis',
      },
      {
        icon: Globe,
        label: 'Maps & Location',
        desc: 'Google Maps APIs for station discovery and GPS payments.',
        link: '/products/maps',
      },
      {
        icon: Lock,
        label: 'Secure Webhooks',
        desc: 'Twilio/SMS alerts, encrypted webhooks, and OAuth2 auth.',
        link: '/products/webhooks',
      },
    ],
  },
  {
    title: 'Future Innovations',
    items: [
      {
        icon: Zap,
        label: 'Blockchain Fuel Tokens',
        desc: 'Tokenized reserves via Stellar/Hyperledger for liquidity.',
        link: '/products/blockchain',
      },
      {
        icon: TrendingUp,
        label: 'AI Route Optimization',
        desc: 'Predictive fueling & delivery optimization for fleets.',
        link: '/products/ai-routing',
      },
      {
        icon: Users,
        label: 'Micro-Investment Marketplace',
        desc: 'Fractional investments in LonaPay fuel-backed assets.',
        link: '/products/micro-invest',
      },
    ],
  },
];

export const partnerships = [
  { icon: Globe, label: 'TotalEnergies Uganda', link: '/partners/totalenergies' },
  { icon: Globe, label: 'Shell Uganda', link: '/partners/shell' },
  { icon: Globe, label: 'MTN Mobile Money', link: '/partners/mtn' },
];

export const resources = [
  { icon: Book, label: 'Company', link: '/resources/company' },
  { icon: Book, label: 'Blog', link: '/resources/blog' },
  { icon: Book, label: 'Whitepapers', link: '/resources/whitepapers' },
  { icon: Layers, label: 'Banks vs LonaPay', link: '/resources/banks-vs-lonapay' },
  { icon: Layers, label: 'Mobile Money vs LonaPay', link: '/resources/mobile-vs-lonapay' },
  {
    icon: Layers,
    label: 'Other Providers Vs LonaPay',
    link: '/resources/other-providers-vs-lonapay',
  },
];
